__turbopack_context__.v({
  "button": "styles-module__aCutFa__button",
  "container": "styles-module__aCutFa__container",
});
